var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item"},[_c('span',[_vm._v(_vm._s(_vm.itemData.ArticleTitle))]),_c('svg-icon',{staticClass:"faq-item-svg",attrs:{"svg-name":"direction-right","width":"20px","height":"20px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }